import CasosPCDModule from "./casosPCD/casosPCD.module"
import CorteExcepcionalModule from "./corteExcepcional/corteExcepcional.module"

const Soporte = angular
  .module('app.soporte', [
    CasosPCDModule,
    CorteExcepcionalModule
  ]).name

export default Soporte



// WEBPACK FOOTER //
// ./src/app/components/soporte/soporte.module.js